import { useEffect, useState } from "react";

const KEY = "mpl-market";
export const MARKETS = [["ALL", "Tous"], ["FR", "France"], ["CA", "Canada"]];
export const MARKET_LABEL = { ALL: "Tous marchés", FR: "France", CA: "Canada", BOTH: "France + Canada" };

export function useMarket() {
  const [m, setM] = useState(() => localStorage.getItem(KEY) || "ALL");
  useEffect(() => {
    const sync = () => setM(localStorage.getItem(KEY) || "ALL");
    window.addEventListener("mpl-market", sync);
    return () => window.removeEventListener("mpl-market", sync);
  }, []);
  const set = (v) => { localStorage.setItem(KEY, v); setM(v); window.dispatchEvent(new Event("mpl-market")); };
  return [m, set];
}

export const fmtMoney = (cents, cur) => (cents == null ? "—" : new Intl.NumberFormat("fr-FR", { style: "currency", currency: cur || "CAD" }).format(cents / 100));
export const fmtDate = (d, tz) => (d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric", ...(tz ? { timeZone: tz } : {}) }) : "");
export const expTz = (market) => (market === "FR" ? "Europe/Paris" : "America/Toronto");
